module.exports = __webpack_public_path__ + "img/food-36.c3d580e1.jpg";